/**
 * Ajax loading of ICE iNAV data every 15 seconds
 */
(function (window, document, $, undefined) {
	'use strict';

	function jh_ice_inav_polling() {
		var every_second = true;

		// Start off polling every second until we land on 0,15,30,45
		if (true === every_second) {
			var interval = 1000;
			var d = new Date();
			var seconds = d.getSeconds();
			var timings = [0, 15, 30, 45];

			if (timings.includes(seconds)) {
				interval = 15000;
				every_second = false;

				// Show the 'loading' overlay
				$('.loading-overlay').show();
				// Call and get the ICE iNAV template part
				$.ajax(
					{
						type: 'GET',
						url: jh_ice_inav.ajax_url,
						data: {
							action: 'jh_ice_inav_refresh',
							product_current_identifier: jh_ice_inav.product_current_identifier
						},
						success: function (response) {
							$('#dynamic-ice-inav-container').replaceWith(response);
							$('.loading-overlay').hide();

							// Also update the "Key Information" table with the latest values
							jh_ice_inav_key_information(response);
						},
						error: function (MLHttpRequest, response, errorThrown) {
							console.log(errorThrown);
						}
					}
				);
			}
		}

		setTimeout(jh_ice_inav_polling, interval);
	}

	// Copy the data into the Key Information table
	function jh_ice_inav_key_information(partial_html) {
		var $response_html = $($.parseHTML(partial_html));
		// Use .text() to preserve exact formatting including trailing zeros
		var ice_inav_value = $response_html.find("#ice-inav-value").text().trim();
		var ice_inav_as_of_date = $response_html.find("#ice-inav-as-of-date").text().trim();

		// Preserve exact formatting by using text() and avoiding any number conversion
		if (ice_inav_value && ice_inav_as_of_date) {
			// Don't parse or convert - just use the exact string
			$('#key-information-dynamic-ice-inav').html(ice_inav_value + ' <span class="as-of">' + ice_inav_as_of_date + '</span>');
		}
	}

	// Only run if the ICE iNAV hero component exists
	if ($('#dynamic-ice-inav-container').length > 0) {
		jh_ice_inav_key_information($('#dynamic-ice-inav-container').html());
		jh_ice_inav_polling();
	}

})(window, document, jQuery);
